import { render, staticRenderFns } from "./IndustryNew.vue?vue&type=template&id=faf5352a&lang=pug&"
import script from "./IndustryNew.vue?vue&type=script&lang=js&"
export * from "./IndustryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports